import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import FormField from "../utility/FormField";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Logo from "../assets/sbw 1.png";
import background from "../assets/background.png";
import Button from "./Button";
import { signUpData, verifyOTP } from "../store/reducers/signup";
import { toast } from "react-toastify";
import { verifyEmail } from "../store/reducers/signup";

const VerifyOTP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formData = location.state?.formData;

  React.useEffect(() => {
    if (!formData) {
      navigate("/signup");
    }
  }, [formData, navigate]);

  if (!formData) return null;

  return (
    <>
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-4 md:col-span-6 lg:col-span-7 xl:col-span-7 2xl:col-span-8"></div>
          {/* <div className="min-h-screen p-8 top-[60px] col-span-8 md:col-span-6 lg:col-span-5 xl:col-span-5 2xl:col-span-4 bg-[#0d223d]/60 backdrop-blur-[80px] shadow-lg flex"> */}
          <div className="
    col-span-1 
    md:col-span-6 
    lg:col-span-5 
    xl:col-span-5 
    2xl:col-span-4 
    flex justify-center
  ">
            <div className="
      min-h-screen p-8 w-full 
      bg-[#0d223d]/60 
      backdrop-blur-[80px] 
      shadow-lg 
      flex flex-col items-center gap-6
    ">
              <div className="w-full flex-col justify-center items-center flex gap-6">
                <>
                  <img src={Logo} />
                </>
                <div className="w-full border-t border-[#b3b5bd]"></div>
                <div className="font-normal text-[#F3F4F8] font-Poppins mb-1 md:mb-2 lg:mb-3 xl:mb-4 2xl:mb-6">
                  <h1 className="text-white mb-6 2xl:mb-8">
                    OTP verification - All the sections are mandatory.
                  </h1>
                  <span className="space-y-2 2xl:space-y-2">
                    <h6 className="text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl leading-[18px]">
                      A 6 digit OTP that has been sent to registered Email ID -{" "}
                      {formData.businessMailId}
                    </h6>
                    <h6
                      onClick={() => {
                        navigate("/signup", { state: { formData } });
                      }}
                      className="text-xs md:text-xs lg:text-sm xl:text-base 2xl:text-lg leading-[14px]"
                    >
                      <button
                        type="button"
                        onClick={() => {
                          // 👉 call your resend OTP logic here
                          // toast.info("Resend OTP triggered");
                        }}
                        className="underline text-gray-100"
                      >
                        Edit email ID
                      </button>
                    </h6>
                  </span>
                </div>
                <Formik
                  initialValues={{ otp: "" }}
                  validationSchema={Yup.object().shape({
                    otp: Yup.string().required("OTP is required"),
                  })}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const payload = {
                        otp: values?.otp,
                        evoren_id: formData?.evoren_id,
                      };
                      const response = await dispatch(verifyOTP(payload));

                      if (response?.payload?.status === "success") {
                        const signupPayload = {
                          primary_contact_firstname: formData.firstName,
                          primary_contact_lastname: formData.lastName,
                          primary_contact_email: formData?.businessMailId,
                          primary_contact_designation: formData.jobTitle,
                          primary_phone_number_country_code: formData.countryCode,
                          primary_phone_number: formData.phoneNumber,
                          org_type: formData.organisationType,
                          org_name: formData.organisationName,
                        };

                        const signupResponse = await dispatch(
                          signUpData(signupPayload),
                        );

                        if (signupResponse?.payload?.status === "success") {
                          navigate("/confirm-signup");
                        } else {
                          toast.error("Signup failed. Please try again.");
                        }
                      } else {
                        toast.error("OTP verification failed");
                      }
                    } catch (error) {
                      toast.error("Unexpected error occurred");
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting, isValid, values }) => {
                    return (
                      <Form className="w-full">
                        <div className="w-full flex justify-center">
                          <div className="w-full max-w-xs">
                            <FormField
                              label="Enter 6 Digit OTP"
                              name="otp"
                              as="otp"
                            />
                          </div>
                        </div>
                        <div className="mt-8 2xl:mt-12">
                          <Button
                            type="submit"
                            disabled={isSubmitting || !isValid}
                            primary={isValid}
                          >
                            Submit OTP
                          </Button>
                        </div>
                        <p className="mt-4 md:mt-4 lg:mt-6 xl:mt-8 2xl:mt-10 text-center text-gray-300 text-xs md:text-xs lg:text-xs xl:text-xs 2xl:text-sm font-normal">
                          Didn’t receive OTP yet?{" "}
                          <button
                            type="button"
                            onClick={async () => {
                              const payload = { primary_contact_email: formData.businessMailId };
                              const response = await dispatch(verifyEmail(payload));
                              if (response?.payload?.status === "success") {
                                toast.success(response.payload.message)
                              }
                            }}
                            className="text-sm underline text-gray-100"
                          >
                            Resend OTP
                          </button>
                        </p>
                      </Form>
                    );
                  }}
                </Formik>

                {/* <Button
                type="submit"
              // disabled={isSubmitting || !isValid || !dirty}
              // primary={isValid && dirty ? true : false}
              >
                Submit OTP
              </Button>
              <div className="text-center">
                Didn’t receive OTP yet? Resend OTP
              </div> */}
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default VerifyOTP;
